import type { ListElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { textToRtValue } from '@vedalib/rich-text'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import * as s from './ListDemo.module.scss'
import Element from './ListElement'
import type { ListDemoType } from './listTypes'

const DEMO_VALUE_NUMBER: ListElementValue = {
  items: [
    {
      label: textToRtValue(t('elements.list.value.item', { count: 1 })),
      value: 'id_number_1',
      number: 1,
      icon: null,
    },
    {
      label: textToRtValue(t('elements.list.value.item', { count: 2 })),
      value: 'id_number_2',
      number: 2,
      icon: null,
    },
    {
      label: textToRtValue(t('elements.list.value.item', { count: 3 })),
      value: 'id_number_3',
      number: 3,
      icon: null,
    },
  ],
  mode: 'number',
}

const DEMO_VALUE_POINT: ListElementValue = {
  items: [
    {
      label: textToRtValue(t('elements.list.value.item', { count: 1 })),
      value: 'id_point_1',
      number: 1,
      icon: null,
    },
    {
      label: textToRtValue(t('elements.list.value.item', { count: 2 })),
      value: 'id_point_2',
      number: 2,
      icon: null,
    },
    {
      label: textToRtValue(t('elements.list.value.item', { count: 3 })),
      value: 'id_point_3',
      number: 3,
      icon: null,
    },
  ],
  mode: 'point',
}

const DEMO_VALUE_POINT_ICON: ListElementValue = {
  items: [
    {
      label: textToRtValue(t('elements.list.value.item', { count: 1 })),
      value: 'id_point_icon_1',
      number: 1,
      icon: null,
    },
    {
      label: textToRtValue(t('elements.list.value.item', { count: 2 })),
      value: 'id_point_icon_2',
      number: 1,
      icon: null,
    },
    {
      label: textToRtValue(t('elements.list.value.item', { count: 3 })),
      value: 'id_point_icon_3',
      number: 1,
      icon: null,
    },
  ],
  mode: 'images',
}

const DemoNumber: ListDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper center>
    <div className={s.pointWrapper}>
      <Element
        element={{
          id: `${CONFIG_ELEMENTS.list.type}-number-demo`,
          type: CONFIG_ELEMENTS.list.type,
          value: DEMO_VALUE_NUMBER,
          style: {},
          font: {},
          feedback: {},
        }}
        feedback={feedback}
        font={fonts}
        mode={DEMO_MODE}
        styles={styles}
      />
    </div>
  </DemoWrapper>
)

const DemoPoint: ListDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper center>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.list.type}-point-demo`,
        type: CONFIG_ELEMENTS.list.type,
        value: DEMO_VALUE_POINT,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

const DemoPointIcon: ListDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper center>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.list.type}-point-icon-demo`,
        type: CONFIG_ELEMENTS.list.type,
        value: DEMO_VALUE_POINT_ICON,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export { DemoNumber, DemoPoint, DemoPointIcon }
